import { useEffect, useState } from 'react';

import { Row, Modal as ModalAntD, Result, Col, Skeleton } from 'antd';
import { Formik } from 'formik';
import moment from 'moment';
import { useHistory, useLocation } from 'react-router-dom';

import * as S from './styled';

import { createSmartCharging } from '../../../hooks/smartcharging';
import {
  createVirtualGroupSmartCharging,
  getAllVirtualGroupChargerboxes,
} from '../../../hooks/virtualgroup';
import SmartChargingForm from '../../organisms/SmartChargingForm/SmartChargingForm';

const Modal: any = ModalAntD;

const SmartChargingCreatePage = () => {
  const history = useHistory();

  const { pathname }: any = useLocation();

  const [id] = useState(pathname.split('/')[3]);
  const [createLoading, setCreateLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(false);
  const [chargeboxs, setChargeboxs] = useState<any>();
  const [loadingChargeboxs, setLoadingChargeboxs] = useState(false);

  const handleCreateSmartCharging = async (values: any) => {
    // Sem a lista completa de estacoes o smart charging nasceria sem parte do grupo
    if (!chargeboxs) {
      return;
    }
    setCreateLoading(true);

    try {
      const { data } = await createSmartCharging({
        enabled: true,
        current_nominal_a: values.smart_charging.current_nominal_a,
        start_date: values.smart_charging.start_date,
        end_date: values.smart_charging.end_date,
        charge_boxs: chargeboxs.content?.map((chargebox) => ({
          charge_box_id: chargebox.charge_box_id,
        })),
        algorithm: values.smart_charging.algorithm,
      });

      await createVirtualGroupSmartCharging({
        virtual_group_id: id,
        enabled: true,
        smart_charging_id: data.smart_charging_id,
      });

      setSuccess(true);
    } catch {
      setTimeout(() => setError(true), 1500);
    } finally {
      setTimeout(() => setCreateLoading(false), 1500);
    }
  };

  useEffect(() => {
    (async () => {
      setLoadingChargeboxs(true);

      try {
        setChargeboxs(await getAllVirtualGroupChargerboxes(id));
      } finally {
        setTimeout(() => setLoadingChargeboxs(false), 2000);
      }
    })();
  }, [id]);

  return (
    <Formik
      validateOnMount
      initialValues={{
        smart_charging: {
          enabled: true,
          start_date: '',
          end_date: '',
          current_nominal_a: '',
          algorithm: '',
        },
      }}
      validate={(values) => {
        const errors: any = {};
        let hasError = false;
        if (values.smart_charging.enabled) {
          errors.smart_charging = {};
          if (!values.smart_charging.start_date) {
            hasError = true;
            errors.smart_charging.start_date =
              'A data de início é um campo obrigatório';
          }
          if (!values.smart_charging.end_date) {
            hasError = true;
            errors.smart_charging.end_date =
              'A data de término é um campo obrigatório';
          }
          if (
            moment(values.smart_charging.start_date).isAfter(
              values.smart_charging.end_date,
            )
          ) {
            hasError = true;
            errors.smart_charging.start_date =
              'A data de início deve ser anterior  a data final';
          }
          if (!values.smart_charging.current_nominal_a) {
            hasError = true;
            errors.smart_charging.current_nominal_a =
              'A corrente nominal do disjuntor (a) é um campo obrigatório';
          }
          if (!values.smart_charging.algorithm) {
            hasError = true;
            errors.smart_charging.algorithm =
              'O algoritmo é um campo obrigatório';
          }
        }
        return hasError ? errors : {};
      }}
      onSubmit={handleCreateSmartCharging}
    >
      {({ handleSubmit }) => {
        return (
          <S.Wrapper>
            <Skeleton
              loading={loadingChargeboxs}
              active
              paragraph={{
                rows: 1,
                width: '30%',
                style: {
                  marginTop: 24,
                },
              }}
              title={false}
            >
              <Row gutter={24}>
                <Col
                  md={24}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    marginTop: 16,
                    marginBottom: 16,
                  }}
                >
                  {chargeboxs && (
                    <>
                      <S.ChargeboxCircle>
                        {chargeboxs?.content?.length}
                      </S.ChargeboxCircle>

                      <S.ChargeboxText>
                        carregador{chargeboxs?.content?.length > 1 ? 'es' : ''}
                      </S.ChargeboxText>
                    </>
                  )}
                </Col>
              </Row>
            </Skeleton>

            <SmartChargingForm
              isCreateSmartCharging
              chargeBoxIds={chargeboxs?.content?.map(
                (chargebox) => chargebox.charge_box_id,
              )}
            />

            <Row style={{ marginTop: 32, justifyContent: 'space-between' }}>
              <S.Button
                disabled={createLoading}
                size='large'
                danger
                onClick={history.goBack}
              >
                Cancelar
              </S.Button>

              <S.Button
                loading={createLoading}
                disabled={loadingChargeboxs || !chargeboxs}
                key='submit'
                size='large'
                type='primary'
                onClick={() => handleSubmit()}
              >
                Criar Smart Charging
              </S.Button>
            </Row>

            <Modal
              visible={success}
              onOk={() => {}}
              onCancel={() => {}}
              closable={false}
              footer={null}
            >
              <Result
                status='success'
                title='Smart Charging criado com sucesso!'
                extra={[
                  <S.Button
                    type='primary'
                    key='console'
                    size='large'
                    onClick={() => {
                      history.push('/virtual-groups');
                    }}
                  >
                    Ver listagem atualizada
                  </S.Button>,
                ]}
              />
            </Modal>

            <Modal visible={error} closable={false} footer={null}>
              <Result
                status='error'
                title='Não foi possível criar o smart charging!'
                extra={[
                  <S.Button
                    type='primary'
                    key='primary'
                    size='large'
                    onClick={() => setError(false)}
                    style={{ marginTop: 16 }}
                  >
                    Voltar para a visualização do grupo
                  </S.Button>,
                ]}
              />
            </Modal>
          </S.Wrapper>
        );
      }}
    </Formik>
  );
};

export default SmartChargingCreatePage;
